import type {GetCustomerPopupsResponse} from '@resurs-internal/rb-app-api';
import {usePopups} from '@resurs-internal/rb-app-api';
import {useDialog} from 'hooks';
import React from 'react';
import {PopupAnnouncementDialog} from './PopupAnnouncementDialog';
import {PopupInformationDialog} from './PopupInformationDialog';
import {PopupRequiredSingleCheckboxDialog} from './PopupRequiredSingleCheckboxDialog';

type PopupItem = GetCustomerPopupsResponse['popups'][number];

export const PopupDialog: React.FC = () => {
  const dialog = useDialog<PopupItem>('popup');
  const popups = usePopups();

  const state = dialog.state;
  if (!dialog.open || !state) return null;

  const onAcknowledge = async () => {
    await popups.confirm.mutateAsync({
      id: state.id,
      body: {type: 'ACKNOWLEDGE'},
    });
    dialog.onClose();
  };

  const onDismiss = async () => {
    await popups.confirm.mutateAsync({id: state.id, body: {type: 'DISMISS'}});
    dialog.onClose();
  };

  if (
    state.template === 'REQUIRED_SINGLE_CHECKBOX' &&
    state.content.requiredSingleCheckbox
  ) {
    return (
      <PopupRequiredSingleCheckboxDialog
        content={state.content.requiredSingleCheckbox}
        onConfirm={onAcknowledge}
        onClose={onDismiss}
        isPending={popups.confirm.isPending}
      />
    );
  }

  if (state.template === 'INFORMATION' && state.content.information) {
    return (
      <PopupInformationDialog
        content={state.content.information}
        onConfirm={onAcknowledge}
        onClose={onDismiss}
        isPending={popups.confirm.isPending}
      />
    );
  }

  if (state.template === 'ANNOUNCEMENT' && state.content.announcement) {
    return (
      <PopupAnnouncementDialog
        content={state.content.announcement}
        onClose={onDismiss}
        isPending={popups.confirm.isPending}
      />
    );
  }

  return null;
};
